import { render, staticRenderFns } from "./Modalidad_actividad.vue?vue&type=template&id=2945c9ae"
import script from "./Modalidad_actividad.vue?vue&type=script&lang=js"
export * from "./Modalidad_actividad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports